var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BootstrapTable',{attrs:{"columns":_vm.columns,"data-url":_vm.data,"options":_vm.options,"data-side-pagination":"server","data-pagination":"true","data-buttons-class":"outline-primary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }